import React, { useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Typography, Button } from '@mui/material';
import { ThemeContext } from 'styled-components';
import SectionHeader from '../../template/components/SectionHeader';

const Logout = ({ modalVisible, setModalVisible, logout, stayLoggedIn, forcedLogout }) => {
    const theme = useContext(ThemeContext);

    const handleClose = () => {
        if (!forcedLogout) {
            stayLoggedIn();
        }
        setModalVisible(false);
    };

    const handleLogout = () => {
        handleClose();
        logout();
    };

    const title = forcedLogout ? 'You have been logged out' : 'Are you there?';
    const description = forcedLogout
        ? 'You have been logged out due to inactivity.'
        : 'Logging you out soon for safety.';

    return (
        <Dialog
            open={modalVisible}
            onClose={handleClose}
            maxWidth={false}
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: theme?.colors?.backgroundPrimary ?? theme?.colors?.primary,
                    color: theme?.colors?.text,
                    borderRadius: '16px',
                    maxWidth: { xs: '95vw', sm: '600px' },
                    width: { xs: '95vw', sm: '70vw' },
                }
            }}
        >
            <DialogTitle sx={{ padding: 0 }}>
                <SectionHeader
                    title={title}
                    borderRadius="16px 16px 0 0"
                    margin={0}
                />
            </DialogTitle>

            <DialogContent sx={{
                paddingTop: 0,
                paddingLeft: 0,
                paddingRight: 0,
            }}>
                <Box sx={{ px: 2, pt: '32px' }}>
                    <Typography variant="body1" sx={{ color: theme?.colors?.text }}>
                        {description}
                    </Typography>
                </Box>
            </DialogContent>

            <Box sx={{
                paddingTop: 3,
                paddingBottom: 3,
                paddingLeft: 0,
                paddingRight: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
            }}>
                <Box sx={{
                    display: 'flex',
                    gap: 2,
                    width: '100%',
                    px: 2,
                }}>
                    {forcedLogout ? (
                        <Button
                            onClick={handleClose}
                            fullWidth
                            variant="outlined"
                            sx={{
                                flex: 1,
                                borderRadius: '8px',
                                borderColor: theme?.current === 'light'
                                    ? theme?.colors?.brandSecondary
                                    : (theme?.colors?.secondary || theme?.colors?.brandSecondary),
                                color: '#ffffff',
                                backgroundColor: theme?.current === 'light'
                                    ? theme?.colors?.brandSecondary
                                    : (theme?.colors?.tableBackground || theme?.colors?.background),
                                '&:hover': {
                                    borderColor: theme?.current === 'light'
                                        ? theme?.colors?.brandSecondary
                                        : (theme?.colors?.secondary || theme?.colors?.brandSecondary),
                                    backgroundColor: theme?.current === 'light'
                                        ? theme?.colors?.brandSecondary
                                        : (theme?.colors?.overlayHover || 'rgba(0, 0, 0, 0.04)'),
                                },
                            }}
                        >
                            Okay
                        </Button>
                    ) : (
                        <>
                            <Button
                                onClick={handleLogout}
                                fullWidth
                                variant="outlined"
                                sx={{
                                    flex: 1,
                                    borderRadius: '8px',
                                    border: `1px solid ${theme?.colors?.border || '#ccc'}`,
                                    backgroundColor: 'transparent',
                                    color: theme?.colors?.text,
                                    '&:hover': {
                                        borderColor: theme?.colors?.border || '#ccc',
                                        backgroundColor: theme?.colors?.overlayHover || 'rgba(0, 0, 0, 0.04)',
                                    },
                                }}
                            >
                                Log Out
                            </Button>
                            <Button
                                onClick={handleClose}
                                fullWidth
                                variant="outlined"
                                sx={{
                                    flex: 1,
                                    borderRadius: '8px',
                                    borderColor: theme?.current === 'light'
                                        ? theme?.colors?.brandSecondary
                                        : (theme?.colors?.secondary || theme?.colors?.brandSecondary),
                                    color: '#ffffff',
                                    backgroundColor: theme?.current === 'light'
                                        ? theme?.colors?.brandSecondary
                                        : (theme?.colors?.tableBackground || theme?.colors?.background),
                                    '&:hover': {
                                        borderColor: theme?.current === 'light'
                                            ? theme?.colors?.brandSecondary
                                            : (theme?.colors?.secondary || theme?.colors?.brandSecondary),
                                        backgroundColor: theme?.current === 'light'
                                            ? theme?.colors?.brandSecondary
                                            : (theme?.colors?.overlayHover || 'rgba(0, 0, 0, 0.04)'),
                                    },
                                }}
                            >
                                Stay Logged In
                            </Button>
                        </>
                    )}
                </Box>
            </Box>
        </Dialog>
    );
};

export default Logout;
